"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigInput = void 0;
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledInputBase = (0, styled_components_1.default)(core_1.InputBase) `
  padding: 0 8px;
  &:hover,
  &:focus-within {
    border: solid 1px #ccc;
    border-radius: 4px;
    margin: -1px;
  }
  &:focus-within {
    background: #fff;
  }
  &.MuiInputBase-multiline {
    padding: 8px;
    background: #f4f4f4;
    &:hover,
    &:focus-within {
      background: #fff;
    }
  }
`;
const ConfigInput = props => {
    return react_1.default.createElement(StyledInputBase, Object.assign({}, props));
};
exports.ConfigInput = ConfigInput;
exports.default = exports.ConfigInput;
//# sourceMappingURL=ConfigInput.js.map